module.exports = __webpack_public_path__ + "img/logo.197d9e88.png";